<template>
  <div>
    <BaseFormLabel
      v-if="label"
      :name="name"
      :label="label"
      :note="note"
      :required="required"
    />

    <textarea
      v-bind="field"
      :name="name"
      :id="name"
      :rows="rows"
      :placeholder="placeholder"
      :disabled="disabled"
      class="textarea w-full px-4 py-3 border rounded leading-4 resize-none"
      :class="{ 'border-danger': errorMessage }"
      @blur="onChange"
      @change="onChange"
    />

    <BaseErrorMessage v-if="errorMessage" :message="errorMessage" />
  </div>
</template>

<script>
import BaseFormLabel from '@/components/form/BaseFormLabel.vue';
import BaseErrorMessage from '@/components/form/BaseErrorMessage.vue';

export default {
  components: {
    BaseFormLabel,
    BaseErrorMessage,
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 3,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    field: {
      type: Object,
    },
    onChange: {
      type: Function,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped>
.textarea {
  outline: none;
  &:focus {
    border: 1px solid #2cb2b2;
    box-sizing: border-box;
    box-shadow: 0px 0px 0px 2px rgba(73, 168, 174, 0.2);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #dde1ed;
    border-radius: 10px;
  }
}
</style>
